<template>
  <div>
    <div class="status">
      <br />
      Boujour {{submission.first_name}} {{submission.last_name}}
      <br />
      <br />
      Votre participation au jeu Gardena un automne d'exception
      <br />
      <br />
      Status de la participation : {{ status }}
      <br />
      <br />
      Produit acheté :  {{ submission.produit_achete }}
      <br />
      <br />
      Enseigne :  {{ submission.enseigne }}
      <br />
      <br />
      Le scan de votre code barre : <a v-bind:href="submission.bar_code" target="_blank">{{ submission.bar_code }}</a>
      <br />
      <br />
      Le scan de votre ticket de caisse : <a  v-bind:href="submission.receipt" target="_blank">{{ submission.receipt }}</a>   
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'Status',
  data: function() {
    return {
      status : 'En attente',
      submission: {},
    };
  },
  async mounted() {
    try {
      let data = await axios.get(
        "https://oxo-form.herokuapp.com/api/data/submission/" + this.$route.params._id
      );

     Vue.set(this, 'submission', data.data);

     if(this.submission.participationValide=='VALID') { this.status = 'Validé' }
     else if(this.submission.participationValide=='INVALID') { this.status = 'Non conforme' }
     else if(this.submission.participationValide=='PENDING') { this.status = 'En attente' }
     else if(this.submission.participationValide=='REFUND_DONE') { this.status = 'Remboursement effectué' }
     else if(this.submission.participationValide=='MISSING') { this.status = 'à corriger' }     

    } catch(error) {
      console.log(error);
    } 
  }
}
</script>      
<style>
a {
  color:#EB4F15;
}
</style>  